// @vendors
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { APIGet, APIPost } from 'utilities/apiHelper';

// @components
import { OKLink } from 'commonsComponents/OKLink';
import OKTooltip from 'commonsComponents/OKTooltip';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { EmptyState } from 'commonsComponents/emptyState';
import ListProducts from 'components/ListProducts/ListProducts';

// @constants
const {
  GET,
  TEXT_WITHOUT_TRANSLATION,
  URL_CONTROLLERS,
  URL_NOTIFICATIONS,
} = require('constants/index');

const { formatText } = require('core/i18n').i18n;

// @styles
require('./ListCategories.scss');

class ListCategories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categoriesNotifications: null,
      error: false,
      loading: true,
    };
  }

  componentDidMount() {
    this.getControllers();
  }

  async getControllers() {
    const { configuration } = this.props;
    try {
      const response = await APIGet(
        configuration,
        GET,
        null,
      );

      const content = await response.body;

      this.setState({
        categoriesNotifications: content,
        error: false,
        loading: false,
      });
    } catch (error) {
      this.setState({
        error: true,
      });
    }
  }

  handleController = (id, type, newValue) => {
    this.changeControllerValues(id, newValue);
  }

  buildListProducts = (category) => {
    const { showProducts, formatText } = this.props;

    if (showProducts) {
      return (
        <ListProducts
          formatText={formatText}
          products={category.categories}
          handleController={this.handleController}
        />
      );
    }

    return null;
  }

  buildDescriptionLinkCategory = (id, description) => {
    const { showProducts, formatText } = this.props;

    if (!showProducts) {
      return (
        <Fragment>
          <div className="list-categories__description__text col-xs-9">
            {!showProducts && (<p>{formatText(`notificationManagement-${description}`)}</p>)}
          </div>
          <div className="list-categories__description__button col-xs-3">
            {!showProducts && (
              <OKLink
                to={`${URL_CONTROLLERS}${id}`}
                modifier="inherit-styles"
              >
                {formatText('notificationManagement-config')}
              </OKLink>
            )}
          </div>
        </Fragment>
      );
    }

    return null;
  }

  buildTooltip = (content) => {
    const { showProducts } = this.props;
    const tooltipText = formatText(`notificationManagement-${content}`);
    if (showProducts && content && !tooltipText.includes(TEXT_WITHOUT_TRANSLATION)) {
      return (
        <OKTooltip
          content={tooltipText}
          offset={[15, 0]}
          placement="right"
        />
      )
    }
    return null;
  }

  buildCategories = () => {
    const { categoriesNotifications, loading } = this.state;
    const { showProducts, configuration, formatText } = this.props;
    const listCategoryTitle = classNames(
      'list-categories__title__name',
      {
        'list-categories__title__open': showProducts,
      },
    );

    if (!loading && categoriesNotifications && categoriesNotifications.products) {
      const categoriesController = showProducts ? categoriesNotifications.products.filter(c => c.title === configuration.idController) : categoriesNotifications.products;
      return (categoriesController.map((category, index) => {
        return (
          <div className="list-categories__card col-md-12" key={index.toString()}>
            <div className="list-categories__title">
              <img src={category.icon} className="list-categories__title__icon" alt="icon" />
              <h2 className={listCategoryTitle}>
                {formatText(`notificationManagement-${category.title}`)}
                {this.buildTooltip(category.info)}
              </h2>
            </div>
            <div className="list-categories__description">
              <div className="list-categories__description__products">
                {this.buildDescriptionLinkCategory(category.title, category.description)}
                {this.buildListProducts(category)}
              </div>
            </div>
          </div>
        );
      }));
    }

    return (<LoadingSection />);
  };

  buildErrorMessage = () => {
    const { formatText } = this.props;

    return (
      <EmptyState
        title={formatText('notificationManagement-errorMessage')}
        primaryText="error"
        iconType="nointernet-banking"
        linkText="Notificaciones"
        linkURL={URL_NOTIFICATIONS}
      />
    );
  }

  async changeControllerValues(posts) {
    const { configuration, handleControllers } = this.props;
    let concatPosts = [];

    for (let i = 0; i < posts.length; i += 1) {
      concatPosts = concatPosts.concat(posts[i]);
    }

    try {

      const response = await APIPost(configuration, concatPosts);

      if (response.ok) {
        handleControllers();
        this.getControllers(); // If user saves changes, we update state with saved values
      } else if (!response.ok) {
        throw Error(response.statusText);
      }
    } catch (error) {
      this.setState({
        error: true,
      });
    }
  }

  render() {
    const { error } = this.state;
    const categories = error ? this.buildErrorMessage() : this.buildCategories();

    return (
      <div className="list-categories row">
        {categories}
      </div>
    );
  }
}

ListCategories.propTypes = {
  showProducts: PropTypes.bool.isRequired,
  configuration: PropTypes.obj,
  formatText: PropTypes.func.isRequired,
  handleControllers: PropTypes.func.isRequired
};

ListCategories.defaultProps = {
  configuration: {},
};

export default ListCategories;
